<template>
  <router-view></router-view>
</template>

<script>
export default {
  name:  '',
  data() {
    return {

    }
  },
}
</script>

<style scoped lang="scss">

</style>
